import { Input } from '@zillow/constellation';
import { Flex, FormField } from '@zillow/constellation';
import React from 'react';
import { prettyInternalTransferCategory } from 'types/accounting/response/eInternalTransferCategory';
import { IInternalTransferData } from 'types/order/escrow/IInternalTransferData';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';
import { useHasFeatureFlag } from '../../../../../../selectors/useHasFeatureFlag';

interface IVoidInternalTransferDetailsProps {
  internalTransfer: IInternalTransferDisbursementFormData | IInternalTransferData;
  destinationAccountName?: string;
}

export const VoidInternalTransferDetails: React.FC<IVoidInternalTransferDetailsProps> = ({
  internalTransfer,
  destinationAccountName,
}) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const bank = internalTransfer.destinationAccount;
  const base = isSpruceWithZillowEnabled ? bank?.legalName : bank?.spruceName;
  const selectedNickname = isZillowClosingEnabled ? bank?.nickname : bank?.spruceNickname;
  const destinationName = selectedNickname ? (base ? `${base} ${selectedNickname}` : selectedNickname) : base;
  return (
    <Flex display={'flex'} flexDirection={'column'} gap={1}>
      <Flex display={'flex'} flexDirection={'row'} gap={1}>
        <FormField
          label="Amount"
          control={<Input value={currencyDisplay(internalTransfer.amountCents, true)} disabled />}
        />
        {internalTransfer.category && (
          <FormField
            label="Category"
            control={
              <Input
                value={prettyInternalTransferCategory[internalTransfer.category] ?? internalTransfer.category}
                disabled
              />
            }
          />
        )}
      </Flex>
      <FormField
        label={'Destination Account'}
        control={<Input value={destinationName ?? destinationAccountName} disabled />}
      />
    </Flex>
  );
};
